import React from "react";

function SelectBox(props) {
  const {
    name,
    productId,
    value,
    onChange,
    available_machines,
    team_machines,
  } = props;
  const isDisabled = props.isDisabled || false;

  return (
    <select
      name={name}
      data-product-id={productId}
      value={value}
      onChange={onChange}
      disabled={isDisabled}
    >
      <option value={0} disabled={isDisabled}>Choose</option>
      {team_machines.map((machine, i) => {
        const index = available_machines.findIndex(
          ii => ii.id === machine.machine
        );

        return (
          <option key={i} value={machine.id} disabled={isDisabled}>
            {index + 1}
          </option>
        );
      })}
    </select>
  );
}

export default SelectBox;



// WEBPACK FOOTER //
// ./src/components/operations/ui-components/OPSelectBox.js